module.exports = __webpack_public_path__ + "static/media/20200901.1e982aa0.jpg";